import { ROUTE_PAYMENT, ROUTE_PAYMENT_VERIFY_PAYMENT } from '@/constants/routes';
import setTitleFromLoader from '@/utils/routing/set-title';
import { RouteObject } from 'react-router-dom';
import { routePaymentVerifyPayment } from './components/verify/payment-verify.route';
import { PPRAPaymentPageWrapper } from '../payment-page-v2/PaymentPageWrapper';

export const routePayment: RouteObject = {
  Component: PPRAPaymentPageWrapper,
  path: ROUTE_PAYMENT,
  children: [
    routePaymentVerifyPayment,
  ],
  loader: setTitleFromLoader('Payment'),
};
